<!-- 废弃 -->
<template>
	<div>
		<myheader :backFlag="false" headTitle="CA认证资料提交"></myheader>
		<div class="header_extend_main">
			<div class="header_extend_back"></div>
			<div class="header_extend_content">
				<div class="all_tips_content_card">
					<div style="margin: .5rem auto .2rem;text-align: center;">
						<img style="width: 3rem; height: 3rem; " :src="review">
						<div class="text12 textcolor666 margin_top_2">提交成功</div>
						<div class="text14 textcolor333 margin_top_3 font_weight_bold">{{corpName}}</div>
					</div>
				</div>
				<div class="all_tips_content_card margin_top_10">
					<div class="text14 textcolor666">审核状态：</div>
					<div class="text14 textcolor333 font_weight_900" style="position: absolute;right:.5rem;top: 1rem;">
						CA认证审核中</div>
					<div class="horizontal_line margin_top_2"></div>
					<div class="text12 textcolor333 margin_top_5">系统会审核CA认证相关资料，审核通过后会为您颁发移动证书。</div>
				</div>
				<div class="all_tips_bottom_card">
					<button class="all_button22 text16 bmain_active" style="width: 100%;" @click="jump()">关闭</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Dialog
	} from 'vant';
	export default {
		data() {
			return {
				//企业名称
				corpName: '',
				//审核中
				review: require('@/assets/images/review.svg'),
				//失败
				fail: require('@/assets/images/fail.svg'),
			}
		},
		methods: {
			// 返回结果后进行跳转下一页
			jump() {
				this.$router.go(-2)
			},
			//初始化
			init() {
				this.corpName = this.$route.query.corpName
			}
		},
		mounted() {
			this.init()
		}
	}
</script>

<style scoped lang="scss">
	@import "../../../styles/global.css";
</style>